import { get, fetchget, post } from "../request.js";

export const ApiGetBookMetadata = {
  get: (rid) => {
    return get(`/api/reslist/detail/${rid}`);
  },
};

export const ApiPostBookRecording = {
  post: (rid, obj) => {
    console.log("post book reading recording");
    console.log(rid, obj);
    return post(`/lazbook/recordspeaking/${rid}`, obj);
  },
};

export const ApiSetReadingRecord = {
  get: (cid, rid, mid, typeid) => {
    // typeid = <asgmtID|daymsnID|taskID>
    if (typeid !== null) {
      return get(
        `/lazbook/setlog/${cid}/${rid}/${mid}?tasktype=${typeid}&action=bookread`
      );
    } else {
      return get(`/lazbook/setlog/${cid}/${rid}/${mid}?action=bookread`);
    }
  },
};

export const ApiSetBookMark = {
  get: (cid, rid, mid, status) => {
    return get(`/lazbook/setbookmark/${cid}/${rid}/${mid}/${status}`);
  },
};

export const ApiBookMarkRecord = {
  get: (cid, rid, mid) => {
    return get(`/lazbook/getbookmark/${cid}/${rid}/${mid}`);
  },
};

export const ApiGetStdRecording = {
  get: (rid) => {
    return fetchget(`/lazbook/recordspeaking/get/${rid}`);
  },
};

export const ApiDeleteStdRecording = {
  get: (rid) => {
    return get(`/lazbook/recordspeaking/delete/${rid}`);
  },
};

export const ApiGetMaterial = {
  get: (pid, colid, rid, mid) => {
    return get(`/resdl/${pid}/${colid}/${rid}/${mid}`);
  },
};
export const ApiGetBookPage = {
  get: (pid, colid, rid, mid) => {
    return get(`/blob/resdl/${pid}/${colid}/${rid}/${mid}`);
  },
};

//  dictionary
export const ApiGetWordTable = {
  get: (rid) => {
    return get(`/book/glossary/${rid}`);
  },
};

export const ApiGetBookmark = {
  get: (cid, rid) => {
    return get(`/bookmark/list/${cid}/${rid}`);
  },
};
export const ApiDeleteBookmark = {
  get: (bookmarkID) => {
    return get(`/bookmark/delete/${bookmarkID}`);
  },
};
export const ApiBookMarkImg = {
  get: (rid, mid) => {
    return get(`/resdl/thumbnail/${rid}/${mid}`);
  },
};
